export const BLUX_ATTRIBUTES = {
  tracking_id: "data-blux-tracking-id",
  item_id: "data-blux-item-id",
};
